import { useSnackbar } from "notistack";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
} from "@mui/material";
import {useEffect, useState} from "react";
import * as React from 'react';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import * as XLSX from 'xlsx';
import sendRequest from "../services/sendRequest";
import MoonLoader from "react-spinners/MoonLoader";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import DownloadIcon from "@mui/icons-material/Download"; // Import

const UnknownProgrammeUpload =({open, close, selected, setRefresh}) => {

const { enqueueSnackbar, closeSnackbar } = useSnackbar()
const [items, setItems] = useState([]);
const [formData, setFormData] = useState({});
const [fullWidth, setFullWidth] = React.useState(true);
const [maxWidth, setMaxWidth] = React.useState('sm');
let [loading, setLoading] = useState(false);
let [color, setColor] = useState("#000000");
const page ="programmes";
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};
const handleClose = () => {
    close();
  };

  useEffect(() => {
  });

  // handle file upload
  const handleFileUpload = e => {
    let isValidRow = true;
    setLoading(true)
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (evt) => {
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const Papa = require('papaparse');
      const fileData = XLSX.utils.sheet_to_csv(ws, { header: 1 });

      // Parse the CSV data
      const parsedData = Papa.parse(fileData, {
        header: false, // Set to true if the first row contains headers
      });

      // Initialize an array to hold column-wise data
      let columns = [];
      const items = [];

      // Iterate through each row
      parsedData.data.forEach((row, rowIndex) => {
        // Iterate through each cell and organize them into columns
        if (row.length != 2) {
          isValidRow = false;
        }
        row.forEach((cell, colIndex) => {
          // Initialize the column array if it doesn't exist
          if (!columns[colIndex]) {
            columns[colIndex] = [];
          }
          // Add the cell to the appropriate column
          columns[colIndex][rowIndex] = cell;
        });
        // Create an object for each row
        const newObject = {
          title: row[0], // Assuming the first column is the title
          custom_id: row[1], // Assuming the second column is the custom_id
          // Add more fields as needed
        };
        items.push(newObject);
      });
      console.log(items);
      if (isValidRow) {
        try {
          const response = await sendRequest({
            requestType: "post",
            endpoint: `${page}/custom_bulk_create_programme/`,
            requestData: {
              items: items,
              email: localStorage.getItem('username'),
            },
          });
          
          if (response.status === 200) {
            setItems([]);
            if(response.data.deal_not_available == true) {
              handleAllTypesOfMessages(response.data.message, 'warning');
            } else {
              handleAllTypesOfMessages(response.data.message, 'success');
            }
            handleClose();
          } else {
            handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
          }
      
        } catch (error) {
          console.error("An error occurred:", error);
          handleAllTypesOfMessages('There is an Error with the file, Please Check the .csv file and Reupload it!', 'error');
        } finally {
          setItems([]);
          setLoading(false);
          handleClose();
        }
      } else {
        setItems([]);
        handleAllTypesOfMessages('Ensure that the file contains only these 2 Columns [Programme Title and Custom ID] in the specified order and does not include any headers', 'warning');
        setLoading(false);
        handleClose();
      }
    };
    reader.readAsBinaryString(file);
  }

  //handleAllTypesOfMessages
  // const handleAllTypesOfMessages = (message, type) => {
  //   enqueueSnackbar(message, {
  //     variant: type,
  //   });
  // };

  //handleAllTypesOfMessages
  const handleAllTypesOfMessages = (message, type) => {
    const action = (key) => (
      <IconButton
      aria-label="close"
      color="inherit"
      onClick={() => closeSnackbar(key)}
      >
      <CloseIcon />
      </IconButton>
    );

    enqueueSnackbar(message, {
      variant: type,
      anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
      },
      persist: true, // <- keeps the snackbar visible until manually closed
      // autoHideDuration: 20000,
      action
    });
  };

  const handleDownloadProgrammeTemplate = () => {
    // Define the data
    const data = [
      [
        "Title",
        "Custom Id",
      ],
      [
        "Test 1",
        "AAA-BBB",
      ],
      [
        "Test 2",
        "AAA-CCC",
      ],
    ];
  
    // Create a workbook and worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Programmes");
  
    // Adjust column widths
    const columnWidths = data[0].map((header) => ({ wch: header.length + 5 }));
    worksheet["!cols"] = columnWidths;
  
    // Write the workbook to a file
    XLSX.writeFile(workbook, "Programme_Bulk.csv");
  };

  return (
    <Dialog
    open={open}
    onClose={() => {
      close();
    }}
    >
      <DialogContent>
        <Dialog
            fullWidth={fullWidth}
            maxWidth={maxWidth}
            open={open}
            onClose={handleClose}
          >
            <MoonLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={40}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            <DialogTitle sx={{ textAlign: 'center' }}>Upload CSV</DialogTitle>
            <DialogContent sx={{ marginBottom: 2 }}>
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
              Upload a CSV file to bulk update Title based on Custom Id values!
              <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownloadProgrammeTemplate}
              >                
              </Button>
              </DialogContentText>
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
                The .CSV file should contains only 2 Columns 1)Title 2)Custom Id with no headers
              </DialogContentText>
              <DialogContentText sx={{ textAlign: 'center' , whiteSpace: 'normal', wordWrap: 'break-word', marginBottom: 2}}>
                <b>A download option is available above to access a sample template for reference before uploading your file. The template file contains the headers as well, but please ensure to remove the headers before uploading.</b>
              </DialogContentText>
              <Box
                noValidate
                component="form"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  m: 'auto',
                  width: 'fit-content',
                }}
              >
              <FormControl sx={{ mt: 2, minWidth: 120 }}>              
                <input type="file" accept=".csv,.xlsx,.xls" onChange={handleFileUpload}/>
              </FormControl>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Close</Button>
            </DialogActions>
          </Dialog>
      </DialogContent>
    </Dialog>
  );
};

export default UnknownProgrammeUpload;
